<template>
  <div id="documents-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=1.5
        position="center left"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>

    <v-card flat color="grey darken-4">
      <v-toolbar card>
        <v-toolbar-title><h1>Doc List</h1></v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-side-icon>
          <v-tooltip left>
            <v-icon slot="activator">mdi mdi-file-document</v-icon>
            <span>I do nothing!</span>
          </v-tooltip>
        </v-toolbar-side-icon>

        </v-toolbar>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
              <v-flex xs4 v-for="doc in documents" :key="doc.title">
                <v-card color="#444444" height="300">
                  <v-card-text>
                    <v-layout column align-center>
                      <v-avatar size="100" :color="getColor(doc)">
                        <v-icon x-large>{{getIcon(doc)}}</v-icon>
                      </v-avatar>
                    </v-layout>
                  </v-card-text> 
                  <v-card-title><h2>{{doc.title}}</h2></v-card-title>
                  <v-card-text style="background-color:#444444">{{doc.description}}</v-card-text>
                </v-card>
              </v-flex>
          </v-layout>
        </v-container>
    </v-card>
    <!-- <card-fill/> -->

    

  </div>
</template>

<script>
import Fill from '../../components/content_fill/FishCardFill'

export default {
  data () {
    return {
      documents: [
        {
          title: 'Business Plan',
          type: 'document',
          description: '5 year business plan for the business plan competition and for future use.',
          icon: 'briefcase',
          due: true
        },
        {
          title: 'Technology Roadmap',
          type: 'diagram',
          description: 'Milestones for the plan of development.',
          icon: 'console-line',
          due: false
        },
        {
          title: 'Technology Overview',
          type: 'document',
          description: 'Explain the technology and the parts included by starting with the highest level and explaining the pieces all the way down to the low level.',
          icon: 'console-line',
          due: false
        },
        {
          title: 'System Process Overview',
          type: 'diagram',
          description: 'High level diagram that demonstrates the process flow of the technology.',
          icon: 'console-line',
          due: false
        },
        {
          title: 'Sprint Schedule',
          type: 'document',
          description: 'Plan a sprint schedule to start working with organization.',
          icon: 'briefcase',
          due: false
        },
        {
          title: 'Patent Disclosure Form',
          type: 'document',
          description: 'Student inventor award requires the submission of a patent disclosure form.',
          icon: 'briefcase',
          due: true
        },
        {
          title: 'User Profiles',
          type: 'document',
          description: 'Create a profile for users that are expected to use AmmoNyte.',
          icon: 'finance',
          due: false
        },
        {
          title: 'User Stories',
          type: 'document',
          description: 'How users are expected to use AmmoNyte.',
          icon: 'finance',
          due: false
        },
        {
          title: 'Use Cases',
          type: 'document',
          description: 'How AmmoNyte will be used.',
          icon: 'finance',
          due: false
        }
      ],
      icons: {
          financial: 'currency-usd',
          development: 'console-line',
          design: 'material-design',
          marketing: 'finance',
          legal: 'gavel',
          business: 'briefcase'
      },
      titleImg: 'https://images.unsplash.com/photo-1531809458435-2070dcd89009?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f9bb1246ba91b2071a35d834e4debdee&auto=format&fit=crop&w=1225&q=80'
    }
  },
  components: {
    'card-fill': Fill
  },
  methods: {
    getIcon: function (document) {
      return this.getMDIcon(document.icon)
    },
    getMDIcon: function (iconName) {
      var iconString = 'mdi mdi-';
      return (iconString + iconName)
    },
    getColor: function (doc) {
      return (doc.due) ? 'accent' : 'primary'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/documentation/Documents.vue